<template>
    <div v-if="formId !== '0'">
        <p class="aditional-form-title">{{Lang.get('common.you_can')}}</p>
        <div class="aditional-form-checkboxes">
            <div class="additional-form-options">
                <div class="option" @change="form.errors.clear('additionalOptions')"
                     v-for="(item,index) in options">
                    <input type="checkbox"
                           v-model="form.additionalOptions"
                           :value="item"
                           :name="index">
                    <label>{{ item }}</label>
                </div>
                <span class="help is-danger text-danger"
                      v-if="form.errors.has('additionalOptions')"
                      v-text="form.errors.get('additionalOptions')">
            </span>
            </div>
            <p class="additional-info-text">*{{Lang.get('common.check_points')}}</p>
        </div>
        <button type="submit" @click="onSubmit">{{Lang.get('common.order')}}</button>
        <widget-loading v-if="form.loading" color="#000"></widget-loading>
    </div>
</template>

<script>
  import WidgetLoading from '../elements/WidgetLoading';

  export default {
    name: "FormAdditionalOrder",
    components: {
      WidgetLoading,
    },
    props: {
      formId: {
        required: true,
      }
    },
    data() {
      return {
        form: new Form({
          formId: '',
          additionalOptions: [],
          type: 'form_additional_order',
          url: location,
        }),
        additionalOptions: [
          'Дополнительные экскурсии от 550 грн',
          'Обед в самолёте от 350 грн',
          'Первые места в самолёте от 350 грн',
          'Бизнес зал в аэропорту от 500 грн',
          'Тел карту GSM от 100 грн',
          'Страховку от 100 грн',
          'Смс предупреждение о переносе рейса или отмене рейса 20 грн'
        ],
          additionalOptionsUa: [
              'Додаткові екскурсії від 550 грн',
              'Обід в літаку від 350 грн',
              'Перші місця в літаку від 350 грн',
              'Бізнес зал в аеропорту від 500 грн',
              'Тел карту GSM від 100 грн',
              'Страховку від 100 грн',
              'Смс попередження про перенесення рейсу або скасування рейсу 20 грн'
          ],
        action: Lang.locale === 'ua' ? '/additional-form' : '/ru/additional-form',
        Lang,
      }
    },
      computed: {
          options() {
              if(Lang.locale === 'ru') {
                  return this.additionalOptions;
              } else {
                  return this.additionalOptionsUa;
              }
          }
      },
    methods: {
      onSubmit() {
        this.form.formId = this.formId;

        this.form.submit('post', this.action).then(res => {
          document.getElementById('additional-form').innerHTML = res;
        }).catch(error => console.log(error));
      },
    },
  }
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/FormAdditionalOrder.vue